module.exports = __webpack_public_path__ + "static/media/logo-dark.eb83d49d.svg";